import { WIDGET_LAYOUT_TYPE, WIDGET_TYPE as WIDGET_TYPE_V1 } from '../../constants/service/app/widgetConstants';
import { ValueOf } from '../common/utils';
import {
  ProductWidgetDetailV2,
  BrandWidgetDetailV2,
  EventWidgetDetailV2,
  BannerWidgetDetailV2,
  TimedealWidgetDetailV2,
  PRODUCT_WIDGET_LAYOUT_TYPE_V2,
  ProductWidgetCreatePayloadV2,
  BRAND_WIDGET_LAYOUT_TYPE_V2,
  BrandWidgetRequestPayloadV2,
  EventWidgetRequestPayloadV2,
  EVENT_WIDGET_LAYOUT_TYPE_V2,
  BANNER_WIDGET_LAYOUT_TYPE_V2,
  TIMEDEAL_WIDGET_LAYOUT_TYPE_V2,
  BannerWidgetRequestPayloadV2,
  TimedealWidgetRequestPayloadV2,
} from './detail';
import { CouponItemV2 } from '../coupons';

export type ExposureWidgetImage = {
  id: number;
  path: string;
  url: string;
  width: number;
  height: number;
};

export type WIDGET_LAYOUT_TYPE = (typeof WIDGET_LAYOUT_TYPE)[(typeof WIDGET_TYPE_V1)[keyof typeof WIDGET_TYPE_V1]];

export type TimedealWidgetInfo = {
  mainTitle: string;
  subTitle?: string;
  memo: string;
  layoutType: WIDGET_LAYOUT_TYPE[keyof WIDGET_LAYOUT_TYPE];
  isUseCoupon: boolean;
  exposurePeriod: {
    startDate: string;
    endDate: string;
  };
};

export type TimedealExposureWidgetItem = {
  id: number;
  img: ExposureWidgetImage[][];
  linkId: number;
  linkType: number;
  memo: string;
  no: number;
  storeId: number;
  storeName: string;
  productId: number;
  productName: string;
  isTodayDelivery: boolean;
  originPrice: number;
  salesPrice: number;
  coupon: CouponItemV2;
  createDate: string;
  discountStartDate: string | null;
  discountEndDate: string | null;
  discountRate: number;
  discountPrice: number;
  mainCategories: string;
  subCategoryCount: number;
  url: string;
};

export const WIDGET_TYPE_V2 = {
  PRODUCT: 'product',
  BRAND: 'brand',
  EVENT: 'event',
  BANNER: 'banner',
  TIMEDEAL: 'timedeal',
} as const;

export type WIDGET_TYPE_V2 = ValueOf<typeof WIDGET_TYPE_V2>;

export type WidgetDetail =
  | ProductWidgetDetailV2
  | BrandWidgetDetailV2
  | EventWidgetDetailV2
  | BannerWidgetDetailV2
  | TimedealWidgetDetailV2;

export type WidgetRequestPayload =
  | ProductWidgetCreatePayloadV2
  | BrandWidgetRequestPayloadV2
  | EventWidgetRequestPayloadV2
  | BannerWidgetRequestPayloadV2
  | TimedealWidgetRequestPayloadV2;

export type WIDGET_LAYOUT_V2 =
  | PRODUCT_WIDGET_LAYOUT_TYPE_V2
  | BRAND_WIDGET_LAYOUT_TYPE_V2
  | EVENT_WIDGET_LAYOUT_TYPE_V2
  | BANNER_WIDGET_LAYOUT_TYPE_V2
  | TIMEDEAL_WIDGET_LAYOUT_TYPE_V2;

export const WIDGET_HOME_TYPE_V2 = {
  MAIN: 'main',
  SUB: 'sub',
} as const;

export type WIDGET_HOME_TYPE_V2 = ValueOf<typeof WIDGET_HOME_TYPE_V2>;
